module.exports = __webpack_public_path__ + "img/icon-service-system-4.f35b1907.svg";